export default __webpack_public_path__ + "static/media/Screenshot_15.7deb5a24.png";